import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { isNotBlank } from '@roc/feature-utils';
import { CreditAuthorizationSignatureStep } from '../../../caf/components/creditAuthorizationSignatureStep';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    docuSignIframe: {
      border: 0,
      height: 'calc(100vh - 170px)',
      width: '100%',
      [theme.breakpoints.down(960)]: {
        height: 'calc(100vh - 110px)',
      },
    },
  })
);

const LegacyDocusignSigning = observer(({ store, handleClose }) => {
  const classes = useStyles();
  const docusignUrl = store?.embeddedDocusignLink;

  useEffect(() => {
    window.addEventListener('message', handleWindowMessage);
    return () => window.removeEventListener('message', handleWindowMessage);
  }, []);

  const handleWindowMessage = (event: MessageEvent) => {
    switch (event.data) {
      case 'borrower-details-verification-docusign-done':
        store?.confirmDocusign(handleClose);
        break;
    }
  };

  return (
    <iframe
      className={classes.docuSignIframe}
      onLoad={() => {}}
      src={docusignUrl}
    />
  );
});

export const PublicCreditInformation = observer(
  ({ store, handleClose = null }) => {
    if (isNotBlank(store?.embeddedDocusignLink)) {
      return <LegacyDocusignSigning store={store} handleClose={handleClose} />;
    }

    const savedForm = store?.borrowerDetailsVerification?.savedForm;
    const requestToken = savedForm?.requestToken ?? store?.requestToken;

    if (!requestToken) {
      return null;
    }

    const personalInfo = {
      ...savedForm,
      ...store?.personalInformationFormStore?.getFormValues(),
    };
    const emailAddress =
      store?.contactDetailsFormStore?.getFormValues()?.emailAddress ??
      savedForm?.emailAddress;

    return (
      <CreditAuthorizationSignatureStep
        requestToken={requestToken}
        personalInfo={personalInfo}
        emailAddress={emailAddress}
        onComplete={() => store?.confirmDocusign(handleClose)}
      />
    );
  }
);
